/** Site-wide announcement banners. */
import { apiRequest } from './client';
import type { Banner } from './types';

export const bannersApi = {
  /** Banners the visitor should see right now. */
  active: () => apiRequest<{ banners: Banner[] }>('/banners/active'),

  /** Every banner, enabled or not -- the admin list. */
  all: () => apiRequest<{ banners: Banner[] }>('/banners'),

  create: (banner: Partial<Banner>) =>
    apiRequest<{ banner: Banner }>('/admin/banners', { method: 'POST', body: banner }),

  toggle: (id: string, enabled: boolean) =>
    apiRequest<{ success: boolean }>(`/admin/banners/${encodeURIComponent(id)}/toggle`, {
      method: 'PUT',
      body: { enabled },
    }),
};
